import angular from 'angular';
import { ITarifaVT } from '../models/tarifavt.model';
import { ConcessionariasVtsService } from '../../../Concessionariasvts/concessionariasvts.service';
import { IConcessionariaGet } from '@modules/Concessionariasvts/models/concessionaria.model';

export class MeurhSolicitacoesalteracoesvtstarifasFormController implements angular.IController {
	static $inject = ['$rootScope', '$scope', 'ConcessionariasVtsService'];

	public entity: ITarifaVT;
	public form: angular.IFormController;
    public action: 'insert' | 'update';
    public entitiesexcluidas: string[];
    public params: {
        empresa: string;
        estabelecimento: string;
    };

    public usoDiario: number | null;
    public concessionaria: IConcessionariaGet;

	constructor(
        public $rootScope: angular.IRootScopeService,
		public $scope: angular.IScope,
        public ConcessionariasVtsService: ConcessionariasVtsService
	) {
        $scope.$on('persona_concessionariasvts_list_finished', (event, args) => {
            if (args.length === 1) {
                this.concessionaria = args[0];
                this.$rootScope.$broadcast('tarifaconcessionariavt_refresh', this.setTarifaConstructor());
            }
        });
	}

    $onInit() {
        if (this.action === 'update' && this.entity.tarifaconcessionariavt?.concessionariavt) {
            this.ConcessionariasVtsService.get(this.entity.tarifaconcessionariavt.concessionariavt)
                .then((response) => {
                    this.concessionaria = response;
                    this.$rootScope.$broadcast('tarifaconcessionariavt_refresh', this.setTarifaConstructor());
                })
                .catch((e) => console.log(e));
        } else {
            this.ConcessionariasVtsService.reload();
        }
    }

	setUsoDiario() {
		if (
            this.valorExiste(this.entity.quantidade) &&
            this.valorExiste(this.entity.tarifaconcessionariavt) &&
			this.entity.quantidade > 0
		) {
			this.usoDiario = Number(this.entity.tarifaconcessionariavt.valor) * this.entity.quantidade;
        } else if (this.valorExiste(this.usoDiario)) {
            this.usoDiario = null;
        }
    }

    setTarifaConstructor() {
        if (this.concessionaria && this.concessionaria.concessionariavt) {
            return {
                'concessionariavt': this.concessionaria.concessionariavt,
                'tarifa_excluir': this.entitiesexcluidas,
                'empresa': this.params.empresa,
                'estabelecimento': this.params.estabelecimento
            };
        }
        return {};
    }

    onSelectConcessionaria() {
        if (!this.concessionaria) {
            return;
        }
        this.$rootScope.$broadcast('tarifaconcessionariavt_refresh', this.setTarifaConstructor());
        this.entity.tarifaconcessionariavt = null;
        this.setUsoDiario();
    }

	valorExiste(valor: unknown) {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
